// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import * as CryptoJS from 'crypto-js';
export const environment = {
  production: false,
  i18nVersion: '20250715',



  //   begin:: local --- IGNORE ---
  URL: 'https://v1api.alqaryahdeveloper.com/',
  API_URL: 'https://v1api.alqaryahdeveloper.com/api/',
  SOCKET_URL: 'https://alqaryahdevelopment.com/',
  BASE_URL: 'https://alqaryah.info/',
  CF_URL: 'https://d23oyd8gfm720i.cloudfront.net/fit-in/',
  CF_PDF_URL: 'https://d23oyd8gfm720i.cloudfront.net/',
  API_AUCT_URL: 'https://v1api.alqaryahdeveloper.com/api/',
  //  end:: local --- IGNORE ---
 
  //   begin:: Sachin --- IGNORE ---
  // URL: 'http://192.168.3.160:3000/',
  // API_URL: 'http://192.168.3.160:3000/api/',
  // SOCKET_URL: 'http://192.168.3.160:5000/',
  // BASE_URL: 'https://alqaryah.info/',
  // CF_URL: 'https://d23oyd8gfm720i.cloudfront.net/fit-in/',
  // CF_PDF_URL: 'https://d23oyd8gfm720i.cloudfront.net/',
  // API_AUCT_URL: 'http://192.168.3.160:3000/api/',
  //  end:: local --- IGNORE ---

  //   begin:: feature --- IGNORE ---
  // API_URL: 'http://localhost:3000/',
  // SOCKET_URL: 'http://localhost:3000/',
  // BASE_URL: 'https://alqaryah.info/',
  // CF_URL: 'https://d23oyd8gfm720i.cloudfront.net/fit-in/',
  // API_AUCT_URL: 'http://localhost:3000/',
  // CF_PDF_URL: 'https://d23oyd8gfm720i.cloudfront.net/',
  //  end:: feature --- IGNORE ---

  //   begin:: dev --- IGNORE ---
  // API_URL: 'https://alqaryahdevelopments.com/api/',
  // SOCKET_URL: 'https://alqaryahdevelopments.com/',
  // BASE_URL: 'https://alqaryah.info/',
  // CF_URL: 'https://d23oyd8gfm720i.cloudfront.net/fit-in/',
  // API_AUCT_URL: 'https://alqaryahdevelopments.com/api/',
  // CF_PDF_URL: 'https://d23oyd8gfm720i.cloudfront.net/',
  //  end:: feature --- IGNORE ---

  //   begin:: dev --- IGNORE ---
  // API_URL: 'https://alqaryahdevelopments.com/api/',
  // SOCKET_URL: 'https://alqaryahdevelopments.com/',
  // BASE_URL: 'https://alqaryah.info/',
  // CF_URL: 'https://d23oyd8gfm720i.cloudfront.net/fit-in/',
  // API_AUCT_URL: 'https://alqaryahdevelopments.com/api/',
  // CF_PDF_URL: 'https://d23oyd8gfm720i.cloudfront.net/',
  //  end:: dev --- IGNORE ---


  // begin:: Production --- IGNORE --- 
  // API_URL: 'https://erpapi.alqaryahauction.com/api/',
  // SOCKET_URL: 'https://erpapi.alqaryahauction.com/',
  // BASE_URL: 'https://alqaryahauction.com/',
  // CF_URL: 'https://d38ysq0a2r9nxs.cloudfront.net/fit-in/',
  // CF_PDF_URL :"https://d38ysq0a2r9nxs.cloudfront.net/",
  // API_AUCT_URL: 'https://erpapi.alqaryahauction.com/api/',
  // end:: Production --- IGNORE ---

  // Microsoft Clarity project id. Leave empty to disable Clarity.
  clarityProjectId: 'yc5ooyd1xd',

  // RSA public key used by AuthInterceptor to encrypt request bodies.
  publicKey: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmiXk/HFPiCuQT9gVjZz0
MqAZ1MeZmqe0JXXrQZFEPL2h1PXlWPXTrG5r6/mvPISiBAbsYmLk7Ngtq6s/1W2R
Q6vBkw+OOBtBiLEMNfsdxnZSCyYQktX1AbMTOlG6PuRI7+OJTplnbxrps0NCFb1B
e7q+y4wf4iWIoqYTzHPewMp1QO8wucCuXg5lFCN5T3Hl8Awdf0qerke7y8FFnqFh
krQsMnP9b7VZQvFF63CF/6AUOEeOgNueWSU8v1D3/Ie3t09cI1Rx9/yRRNmsFwWY
AY6Nyo2J9nsueFptueKp8N6tWqVzDzHbiTJePzth4G8kLHeEFf3oy+FtuokEzAUB
UQIDAQAB
-----END PUBLIC KEY-----`,

  firebase: {
    apiKey: 'AIzaSyBplLKx7qsDl7JEeB8FATccyLlV-asWyYQ',
    authDomain: 'al-qaryah-auction-6b2ae.firebaseapp.com',
    projectId: 'al-qaryah-auction-6b2ae',
    storageBucket: 'al-qaryah-auction-6b2ae.firebasestorage.app',
    messagingSenderId: '690813514559',
    appId: '1:690813514559:web:de144ad93ba3f59a73598a',
    measurementId: 'G-2GT29Q282C',
  },
};